import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitMaintenancePage } from '@/loaders/unit.maintenance.loader';
import { UnitMaintenancePage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/maintenance/')({
  component: UnitMaintenancePage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitMaintenancePage,
});
